/**
 * Base css generation and global js logic
 */

import $ from 'jquery';
import eventTypes from './events/event-types';

import './_base.scss';

export default {
  minMobileBreakpoint: window.matchMedia('(min-width: 1140px)'),
  event: eventTypes,
};

(function rowAlign() {
  const $rows = $('._row');
  let lastDir;
  $rows.each((i, el) => {
    const $el = $(el);
    if ($el.is('._row-flex--right')) {
      lastDir = 'right';
    }
    if ($el.is('._row-flex--left')) {
      lastDir = 'left';
    }
    if (!$el.is('._row-flex--auto')) { return; }
    if (!lastDir) {
      lastDir = 'right';
    } else {
      lastDir = lastDir === 'right' ? 'left' : 'right';
    }
    $el.removeClass('_row-flex--auto');
    $el.addClass(`_row-flex--${lastDir}`);
  });
}());

(function mobileMenuExtension() {
  $('.navbar .navbar-toggler').click(() => {
    $('.navbar .dropdown-menu').removeClass('show');
    $('li.active').each((i, el) => {
      const $parent = $(el).parent();
      if ($parent.hasClass('dropdown-menu') && !$parent.hasClass('show')) {
        $parent.addClass('show');
      }
    });
  });
}());
